export const backendBaseUrl = "https://mrd.remidio.com";
export const apiToken =
  "eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJiNWY0ZWU5NS0wNjc1LTQ5YjUtOTVkOC00YjRmMDBlODUxYmEiLCJpc3MiOiJodHRwczovL2RpY29tLXNlY3VyZS1zdGFnaW5nLmFwcHNwb3QuY29tIiwic3ViIjoiNTYzMjQ5OTA4MjMzMDExMiIsImlhdCI6MTU4Njk1MTAxMn0.qAIBC7Wyn3Or2iWFqk4vKlIYH0GF_Y-vNCk5xQJnaXk";
